import React from "react";
import { Autocomplete, Box, Paper, TextField } from "@mui/material";
import { commonFieldSx, commonMenuPaperSx } from "./dropdownStyles";

const normalizeOption = (item) =>
  typeof item === "object" ? item : { value: item, label: item };

export default function AppAutocomplete({
  label,
  value = "",
  onChange,
  options = [],
  required = false,
  disabled = false,
  error = false,
  helperText,
  placeholder = "Nhập để tìm kiếm...",
  className,
  sx,
  noOptionsText = "Không tìm thấy dữ liệu",
  paperHeader,
  paperSx,
  renderOption,
  renderGroup,
  groupBy,
  groupLabelSx,
  filterOptions,
  multiple = false,
}) {
  const normalizedOptions = options.map(normalizeOption);
  const selected = multiple
    ? normalizedOptions.filter((item) =>
      (Array.isArray(value) ? value : []).some(
        (selectedValue) => String(selectedValue) === String(item.value)
      )
    )
    : normalizedOptions.find((item) => String(item.value) === String(value)) || null;
  const PaperComponent = paperHeader
    ? ({ children, ...paperProps }) => (
      <Paper {...paperProps}>
        {paperHeader}
        {children}
      </Paper>
    )
    : undefined;

  return (
    <Autocomplete
      className={className}
      sx={{ ...commonFieldSx, ...sx }}
      size="small"
      fullWidth
      disabled={disabled}
      multiple={multiple}
      options={normalizedOptions}
      value={selected}
      autoHighlight
      clearOnEscape
      openOnFocus
      noOptionsText={noOptionsText}
      getOptionLabel={(option) => option?.label || ""}
      isOptionEqualToValue={(option, current) => String(option.value) === String(current.value)}
      onChange={(_, option, reason) => {
        if (multiple) {
          const selectedOptions = Array.isArray(option) ? option : [];
          onChange?.(
            selectedOptions.map((item) => item.value),
            selectedOptions
          );
          return;
        }

        onChange?.(reason === "clear" ? "" : option?.value ?? "", option);
      }}
      PaperComponent={PaperComponent}
      renderOption={renderOption}
      groupBy={groupBy}
      renderGroup={renderGroup || ((params) => (
        <Box component="li" key={params.key}>
          <Box
            sx={{
              px: 1.5,
              py: 0.75,
              color: "#1f2937",
              fontSize: 13,
              fontWeight: 700,
              lineHeight: 1.25,
              backgroundColor: "#f8fafc",
              borderBottom: "1px solid #edf0f3",
              ...groupLabelSx,
            }}
          >
            {params.group}
          </Box>
          <Box component="ul" sx={{ p: 0 }}>{params.children}</Box>
        </Box>
      ))}
      filterOptions={filterOptions}
      slotProps={{
        paper: { sx: { ...commonMenuPaperSx, ...paperSx } },
        listbox: { sx: { maxHeight: 268 } },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          required={required}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
}
